// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2uM1z","loaderOuter":"PageOverlayLoader_loaderOuter__2H997"};